<template>
    <div class="Frota-Principal">
        <PageTitle icon="fa fa-bus" main="Frota"
            sub="Soltura da frota" />
        <div class="Sac-Principal">
            <b-card no-body>
                <b-tabs>                    
                    <b-tab title="Frota" active><FrotaMonitoramento /></b-tab>                                                                                                                        
                </b-tabs>
            </b-card>
        </div>
    </div>
</template>

<script>
import PageTitle from '../template/PageTitle'
import FrotaMonitoramento from '../operacao_frota/FrotaMonitoramento'
export default {
    name: 'FrotaPrincipal',    
    components: { PageTitle, FrotaMonitoramento}
    
}
</script>

<style>

</style>






